import { render, staticRenderFns } from "./editDocumentAgencyIssued.vue?vue&type=template&id=fb01f03a&scoped=true&"
import script from "./editDocumentAgencyIssued.vue?vue&type=script&lang=js&"
export * from "./editDocumentAgencyIssued.vue?vue&type=script&lang=js&"
import style0 from "./editDocumentAgencyIssued.vue?vue&type=style&index=0&id=fb01f03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb01f03a",
  null
  
)

export default component.exports